import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { backend } from '@shared/datastore/core';
import { projectFeedBackend } from './project-feed.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { projectFeedReducer } from './project-feed.reducer';

// FIXME: remove that
backend.projectFeed = projectFeedBackend;

@NgModule({
  imports: [
    StoreModule.forFeature('projectFeed', projectFeedReducer),
    /* DatastoreBackendModule.forFeature(
      'projectFeed',
      projectFeedBackend,
    ),*/
  ],
})
export class DatastoreProjectFeedModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/project-feed/project-feed.module.ts